// store.js
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import {
  langReducer,
  userTypeReducer,
  dataUser,
  infoDataReducer,
  timerReducer,
  listMetalsReducer,
  groupListReducer,
  groupFinishListReducer,
  listAleacionOptionReducer,
  incidentCount,
  cantidadReducer,
  pesosReducer,
  eFabricaReducer,
  authQualityUsersReducer,
  calendarioReducer,
} from "./reducers";

const rootReducer = {
  lang: langReducer,
  userType: userTypeReducer,
  user: dataUser,
  infoData: infoDataReducer,
  timer: timerReducer,
  listMetals: listMetalsReducer,
  groupList: groupListReducer,
  groupFinishList: groupFinishListReducer,
  listAleacionOption: listAleacionOptionReducer,
  totalIncident: incidentCount,
  cantidad: cantidadReducer,
  pesosList: pesosReducer,
  eFabrica: eFabricaReducer,
  authQualityUsers: authQualityUsersReducer,
  calendario: calendarioReducer,
};

const store = configureStore({
  reducer: rootReducer,
  middleware: [thunk],
  // Otros parámetros de configuración
});

export default store;
